import Http, {Data} from "front-component/Http";
import _ from "lodash";
import store from "@/store";

export default abstract class AbstractRepository {
    protected static resource: string = "";

    protected static defaultFields: string[] = [];

    protected static get defaultFilters(): object {
        return {ownerUuid: _.get(store, "getters.getCurrentOwnerUuid", "")};
    }

    public static getSearchUrl(): string {
        return `/search/${this.resource}`;
    }

    public static getListUrl(): string {
        return `/list/${this.resource}`;
    }

    public static getCreateUrl(): string {
        return `/create/${this.resource}`;
    }

    public static getSaveUrl(): string {
        return `/save/${this.resource}`;
    }

    public static getDeleteUrl(): string {
        return `/delete/${this.resource}`;
    }

    public static get(params: object = {}): Promise<object[]> {
        if (!_.has(params, "fields")) {
            _.set(params, "fields", this.defaultFields);
        }

        if (!_.has(params, "filters")) {
            _.set(params, "filters", this.defaultFilters);
        }

        return new Promise((resolve: (value: object[]) => void, reject) => {
            Http.search(
                this.getSearchUrl(),
                params,
                (data: Data) => {
                    resolve(data.data);
                },
                reject
            );
        });
    }

    public static create(params: object = {}, overload: object = {}) {
        if (!_.has(params, "fields")) {
            _.set(params, "fields", this.defaultFields);
        }

        return new Promise((resolve: (value: object) => void, reject) => {
            Http.create(
                this.getCreateUrl(),
                params,
                (data: Data) => {
                    resolve(
                        _.assign(
                            data.data,
                            overload
                        )
                    );
                },
                reject
            );
        });
    }

    public static save(data: object, params: object = {}) {
        if (!_.has(params, "fields")) {
            _.set(params, "fields", this.defaultFields);
        }

        return new Promise((resolve: (value: object) => void, reject) => {
            Http.save(
                this.getSaveUrl(),
                _.assign(params, {data}),
                (result: Data) => {
                    resolve(result.data);
                },
                reject
            );
        });
    }

    public static delete(data: object, params: object = {}) {
        if (!_.has(params, "fields")) {
            _.set(params, "fields", {});
        }

        return new Promise((resolve: (value: object) => void, reject) => {
            Http.delete(
                this.getDeleteUrl(),
                _.assign(params, {data}),
                (result: Data) => {
                    resolve(result.data);
                },
                reject
            );
        });
    }

    public static list(queryParams: object = {}) {
        return new Promise((resolve: (value: object) => void, reject) => {
            Http.get(
                this.getListUrl(),
                queryParams,
                (result: Data) => {
                    resolve(result.data);
                },
                reject
            );
        });
    }
}
